import { useHeader } from 'utils/use-header'

import BreadCrumbs from 'components/ui/bread-crumbs'

import { useTranslation } from 'utils/use-translation'

import MainBlock from './components/main-block'
import PartnerTools from './components/partner-tools'
import CalculateProfit from './components/calculate-profit'
import ContactUs from './components/contact-us'
import OurPartners from './components/our-partners'

export default function Partners() {
  const { t } = useTranslation()

  const head = useHeader(
    t('how_become_partner'),
    t('become_partner_of_coinrabbit') + t('checkout_contact'),
    null,
    3,
    t('partners'),
  )

  return (
    <>
      {head}
      <MainBlock />
      <PartnerTools />
      <CalculateProfit />
      <OurPartners />
      <ContactUs />
      <BreadCrumbs pages={[{ name: t('for_partners'), url: '' }]} />
    </>
  )
}
